import { Injectable } from '@angular/core';
import { TrpcService } from '../trpc/trpc.service';
import { ContactPaymentRequest, KeyCardStatusRequest, MergeContactsRequestParams, paymentMethod, VehicleInfo } from '../../../../../express-tRPC/src/shared/types';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  constructor(private trpcService: TrpcService) { }

  chargeContactActivationFees(contactPaymentRequest: ContactPaymentRequest) {
    return undefined as any;
  }

  chargeContact(params: any) {
    return this.trpcService.trpc.authRouter.saveTenantContacts.mutate(params);
    // return this.trpcService.trpc.parkingServiceChangeRequest.chargeContactNew.mutate(contactPaymentRequest)
  }

  getTenantContactServiceInfo() {
    return this.trpcService.trpc.authRouter.getTenantContactServiceInfo.query();
  }

  getLocationSettings() {
    // we have used any to make sute this method doesn't throw error
    return undefined as any;
  }

  //We need to defined this method for attendant side so shared componenet doesn't thorow error
  getPaymentMethods(module: string) {
    return undefined as any;
  }

  getAccountDetails(suite: string = '', account: string = '') {
    return this.trpcService.trpc.authRouter.getAccountDetails.query({suite: suite, account: account});
  }

  getStates() {
    return this.trpcService.trpc.authRouter.getStates.query();
  }

  saveContacts(params: any) {
    return this.trpcService.trpc.authRouter.saveTenantContacts.mutate(params);
  }

  keyCardActions(params: KeyCardStatusRequest) {
    return this.trpcService.trpc.authRouter.keyCardActions.mutate(params);
  }

  validateVehiclesInfo(params: VehicleInfo[]) {
    return this.trpcService.trpc.authRouter.validateVehiclesInfo.mutate(params);
  }

  savePaymentMethod(params: paymentMethod) {
    return undefined as any;
  }

  checkLPRStatus() {
    return this.trpcService.trpc.monthly_invoice.checkLPRStatus.query();
  }

  mergeContacts(params: MergeContactsRequestParams) {
    return this.trpcService.trpc.surepark.mergeSubscriberIdentifiers.mutate(params);
  }
}
